import React from 'react';
import { p } from '../../../i18n/useP';

/**
 * PrintReportHeader — en-tête standard d'un rapport imprimable.
 *   sur-titre (eyebrow) = catégorie du menu (People / Time / Costing / …)
 *   titre                = nom de la page + année
 * Tout en anglais.
 */
export default function PrintReportHeader({ category, title, year, tenant, unit }) {
  // La date d'impression vit en pied de page (footer fixe --ppl-footer-left),
  // plus dans l'en-tête (demande 2026-08-19).
  // Unité d'affichage des montants (rapports financiers) : suffixe après
  // l'année, en corps réduit (l'unité ne rivalise pas avec le titre).
  const unitLabel = unit
    ? <span className="ppl-print__report-unit"> · {unit === 'chf' ? 'CHF' : 'kCHF'}</span>
    : null;
  return (
    <header className="ppl-print__report-header">
      <div>
        <div className="ppl-print__report-eyebrow">{category}</div>
        <h2 className="ppl-print__report-title">{title}{year ? ` · ${year}` : ''}{unitLabel}</h2>
      </div>
      <div className="ppl-print__report-meta">
        <div><strong>{tenant?.name}</strong></div>
      </div>
    </header>
  );
}
